import { jsx as P } from "react/jsx-runtime";
import { BadRequest as _ } from "@systemeio/util";
import q from "../../../../ui-kit/theme-button.mjs";
import { useStripeApi as x } from "../../api/stripe-api.mjs";
import { useStripe as D, useElements as H } from "../../../../node_modules/@stripe/react-stripe-js/dist/react-stripe.esm.mjs";
import { getStripeCardConfirmHandler as O } from "../utils/get-stripe-card-confirm-handler.mjs";
import { useStore as T } from "../../../../store/index.mjs";
import { twJoin as j } from "tailwind-merge";
function G({
  isFetching: f,
  buttonTitle: d,
  buttonDisabled: u,
  setErrors: i,
  setIsFetching: a,
  preSubmit: p,
  handleBadRequest: y,
  hasErrors: w
}) {
  const { locale: h } = T(), { stripeCardBuyOffer: g, confirmPaymentIntent: S } = x(), r = D(), n = H(), b = async (C) => {
    if (C.preventDefault(), !(!r || !n)) {
      a(!0);
      try {
        const t = p();
        if (!t) return;
        const { error: B } = await n.submit();
        if (B) return;
        const { paymentMethod: o, error: m } = await r.createPaymentMethod({
          elements: n,
          params: {
            billing_details: {
              address: {
                country: null,
                line1: null,
                line2: null,
                city: null,
                state: null,
                postal_code: null
              }
            }
          }
        });
        if (m) {
          i((e) => ({
            ...e,
            common: [...e.common, m.message]
          }));
          return;
        }
        if (!o)
          throw Error("undefined payment method");
        const { redirect: s, intentSecret: l, intentType: E } = await g(
          { ...t, options: { stripePaymentMethodId: o.id } },
          h
        );
        if (!l) return window.location.href = s;
        const M = O(r, E), { error: c } = await M(l, {
          payment_method: o.id
        });
        c ? i((e) => ({ ...e, common: [...e.common, c.message] })) : (await S(), window.location.assign(s));
      } catch (t) {
        if (t instanceof _)
          y(t);
        else
          throw t;
      } finally {
        a(!1);
      }
    }
  };
  return /* @__PURE__ */ P(
    q,
    {
      disabled: u,
      className: j("main-transition-colors", w && "bg-danger focus:bg-danger"),
      onClick: b,
      isFetching: f,
      type: "submit",
      children: d
    }
  );
}
export {
  G as StripeCardPaymentButton
};
